import { Controller } from 'stimulus'
import iziToast from 'izitoast/dist/js/iziToast'
import Rails from '@rails/ujs'

export default class RitualController extends Controller {
  static targets = ['form', 'textfield', 'textVal', 'view', 'deleteBtn']

  connect () {
    // console.log('ritual connect')
    this.id = this.data.get('id')
    this.url = this.data.get('url')
    this.ritualItems = document.querySelectorAll(`[data-ritual-item-id='${this.id}']`)
    // StimulusReflex.register(this)
  }

  onPostSuccess (event) {
    const [data, status, xhr] = event.detail
    // console.log(xhr.response)

    for (var i = 0; i < this.ritualItems.length; i++) {
      const ritualItem = this.ritualItems[i]
      ritualItem.innerHTML = xhr.response
    }
  }

  submit (e) {
    Rails.fire(this.formTarget, 'submit')
  }

  deleteConfirm (event) {
    const that = this

    event.preventDefault()
    const url = this.deleteBtnTarget.dataset.url

    iziToast.question({
      timeout: 20000,
      close: false,
      overlay: true,
      displayMode: 'once',
      id: 'confirmRitualDelete',
      zindex: 9999,
      title: 'Confirm',
      message: 'Are you sure you want to delete this ritual?',
      position: 'center',
      buttons: [
        ['<button><b>YES</b></button>', function (instance, toast) {
          instance.hide({ transitionOut: 'fadeOut' }, toast, 'button')
          that.delete(event, url)
          return true
        }, true],
        ['<button>NO</button>', function (instance, toast) {
          instance.hide({ transitionOut: 'fadeOut' }, toast, 'button')
          return false
        }]
      ]
    })
  }

  delete (event, url) {
    const that = this
    Rails.ajax({
      type: 'delete',
      url: url,
      success: function (response) {
        that.deleteSuccess(event)
      },
      error: function (response) {
        iziToast.warning({
          title: 'Error',
          message: 'We encountered an error when deleting this ritual.'
        })
      }
    })
  }

  deleteSuccess (event) {
    this.element.parentNode.removeChild(this.element)
    for (var i = 0; i < this.ritualItems.length; i++) {
      const ritualItem = this.ritualItems[i]
      // console.log(ritualItem)
      ritualItem.remove()
    }
  }
}
